import { Pipe, PipeTransform } from '@angular/core';
import * as R from 'ramda';

import { I18nService } from '../../@core/utils';

@Pipe({
    name: 'thousandsSeparator',
    standalone: true
})
export class ThousandsSeparatorPipe implements PipeTransform {

  constructor(
    private i18n: I18nService,
  ) { }

  transform(value: number): string {
    if (!R.isNil(value)) {
      return new Intl.NumberFormat(this.i18n.getCulture(), { style: 'decimal' }).format(
        Math.round(value)
      );
    }
  }
}
